import { FiMoreVertical } from "react-icons/fi";
import { Link } from "react-router-dom";
import { Dropdown, Popover, Whisper, Button } from "rsuite";
import styled from "styled-components";

const ButtonContainer = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;

  &:hover {
    background: none;
  }
  svg {
    font-size: 16px;
    color: var(--clr-black);
  }
`;

const PopoverContainer = styled(Popover)`
  display: flex;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 5px;
  border: 1px solid var(--clr-white-100);
  background: rgba(255, 255, 255, 0.45);
  backdrop-filter: blur(2px);

  .rs-dropdown-item {
    color: var(--clr-black);
    font-size: 12px;
    font-style: normal;
    font-weight: var(--fw-bold);
    line-height: 16px;
  }
`;

const renderSpeaker = (
  { onClose, left, top, className, ...rest }: any,
  ref: any,
  studentId?: string,
  studentType?: any
) => {
  return (
    <PopoverContainer
      ref={ref}
      className={className}
      style={{ left, top }}
      full
    >
      <Dropdown.Menu>
        <Dropdown.Item eventKey={1}>
          <Link
            to={`/Students/${
              studentType === 1 ? "Admitted" : "Converted"
            }/${studentId}/profile`}
            style={{ color: `#000` }}
          >
            View Profile
          </Link>
        </Dropdown.Item>
        <Dropdown.Item eventKey={2}>
          <Link
            to={`/Students/${studentId}/payment-history`}
            style={{ color: `#000` }}
          >
            View Payments
          </Link>
        </Dropdown.Item>
      </Dropdown.Menu>
    </PopoverContainer>
  );
};

interface StudentMoreProps {
  studentId?: string;
  studentType?: any;
}

const StudentsMoreDropdown = ({ studentId, studentType }: StudentMoreProps) => {
  return (
    <Whisper
      placement="bottomStart"
      trigger="click"
      speaker={renderSpeaker(``, ``, studentId, studentType)}
    >
      <ButtonContainer>
        <span>
          <FiMoreVertical />
        </span>
      </ButtonContainer>
    </Whisper>
  );
};

export default StudentsMoreDropdown;
